import { createContext, useContext, useState } from "react";
import type { SessionReportResponse } from "@rnavoyager/contracts";

/** 重试由会话工作区接纳，随后恢复同一条事件流。 */
export const ReportActionsContext = createContext<{
  currentReportId: string | null;
  current?: SessionReportResponse | null;
  busy: boolean;
  retry(report: Pick<SessionReportResponse, "revision" | "evidenceDigest">): Promise<void>;
} | null>(null);

/** 尚未写出文档就中止时，仍从当前尝试提供重试入口。 */
export function MissingReportNotice() {
  const actions = useContext(ReportActionsContext);
  const [error, setError] = useState("");
  const current = actions?.current;
  if (
    !actions ||
    !current ||
    current.document?.report ||
    !["failed", "cancelled"].includes(current.status)
  )
    return null;
  return (
    <div role="status">
      <p>研究结果已保留，报告{current.status === "cancelled" ? "已取消" : "交付失败"}。</p>
      <button
        type="button"
        disabled={actions.busy}
        onClick={() => {
          setError("");
          void actions
            .retry(current)
            .catch((cause: unknown) =>
              setError(cause instanceof Error ? cause.message : "报告重试未接纳"),
            );
        }}
      >
        重试报告
      </button>
      {error && <p role="alert">{error}</p>}
    </div>
  );
}
